import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Col, FormGroup, InputGroup, Row } from "reactstrap";
import { AvField } from "availity-reactstrap-validation";
import CustomMultipleDateRange from "../../../components/CustomMultipleDateRange/CustomMultipleDateRange";

const EditVoucherItems = ({ num, key, keys, onDelete, items, fixedData }) => {
  return (
    <StyledRow className="justify-content-between fade-in-custom-animate-1s">
    <AvField
        name={`id|${keys}`}
        placeholder="id"
        value={items.id || ""}
        type="number"
        className="form-control d-none"
      />
      <AvField
        name={`offer_name|${keys}`}
        placeholder="offer_name"
        value={fixedData.offer_name || ""}
        type="text"
        className="form-control d-none"
      />
      <AvField
        name={`media_buyer|${keys}`}
        placeholder="media_buyer"
        value={fixedData.media_buyer|| ""}
        type="text"
        className="form-control d-none"
      />
      <Col sm={6}>
        <PickerStyled>
          <label htmlFor="">Date:</label>
          <FormGroup className="mb-3">
            <CustomMultipleDateRange
              placeholder="Select date..."
              name={`date|${keys}`}
              name_id={`date-for-plans-${keys}-data`}
              defaultValue={items.date || ""}
              datePickerType={"calendar"}
              errorText="Date from is required!"
              required
            />
          </FormGroup>
        </PickerStyled>
      </Col>
      <Col sm={6} className="mt-1 mb-1">
        <label htmlFor="">Voucher:</label>
        <AvField
          name={`voucher|${keys}`}
          placeholder="Voucher..."
          type="number"
          className="form-control"
          value={items.voucher || ""}
          validate={{
            required: {
              value: true,
              errorMessage: "Please, enter a voucher",
            },
          }}
        />
      </Col>
      <div className="delete-button--plan">
        <button
          type="button"
          className="btn btn-danger btn-sm delete-button--btn"
          onClick={onDelete}
        >
          <i className="mdi mdi-trash-can d-block font-size-8" />
        </button>
      </div>
    </StyledRow>
  );
};

const PickerStyled = styled(InputGroup)`
  flex-direction: column;
  margin-top: 4px;

  p {
    margin-bottom: 6px;
  }

  input {
    width: 100% !important;
    min-width: 40px !important;
    height: 38px;
    font-size: 12px;
    background: #fff !important;
  }
`;

const StyledRow = styled(Row)`
  position: relative;
  margin: 0;
  margin-bottom: 10px;
  padding: 20px;
  border: 1px solid #dcdde2;
  box-sizing: border-box;
  border-radius: 3px;

  .delete-button--plan {
    .delete-button--btn {
      position: absolute;
      top: -96px;
      right: -10px;
    }
  }
`;

EditVoucherItems.propTypes = {
  keys: PropTypes.string.isRequired,
  key: PropTypes.number.isRequired,
  num: PropTypes.number.isRequired,
  onDelete: PropTypes.func,
  items: PropTypes.object,
  fixedData: PropTypes.object,
};

export default EditVoucherItems;